import { render, staticRenderFns } from "./AppStatistics.vue?vue&type=template&id=3674a1cb&lang=pug"
import script from "./AppStatistics.vue?vue&type=script&lang=js"
export * from "./AppStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports